import React, { Fragment, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { UserActions } from "../redux/UserActions";
import { API_URL, moodValues } from "../redux/constants";

export default function UserProfile() {
  const userState = useSelector((state) => state.user);
  const userId = useParams().id;
  const dispatch = useDispatch();

  const userData = userState.users.find(
    (orgUser) => orgUser._id.$oid === userId
  );

  const [moods, setMoods] = useState([]);

  useEffect(() => {
    setMoods(userState.currentUserMoods);
  }, [userState.currentUserMoods]);

  useEffect(() => {
    dispatch(UserActions.getUserMoods({ user: userId }));
  }, []);

  return (
    <div className="flex flex-col p-4 bg-gray-50 h-screen w-full gap-y-4 overflow-y-hidden ">
      <div className="flex flex-col md:flex-row gap-x-8 gap-y-4 h-24 items-center justify-center w-full bg-blue-200 rounded-lg p-4">
        <img
          className="flex h-20 w-20 rounded-full object-cover"
          src={API_URL + "image/profile/" + String(userId)}
        />
        <span className="flex flex-col items-center ">
          <label className="text-md ">Name:</label>
          <label className="font-semibold text-xl ">
            {userData?.firstName + " " + userData?.lastName}
          </label>
        </span>
        <span className="flex flex-col items-center ">
          <label className="text-md ">Phone Number:</label>
          <label className="font-semibold text-xl ">
            {"+" + userData?.phone.code + " " + userData?.phone.number}
          </label>
        </span>
        <span className="flex flex-col items-center ">
          <label className="text-md ">Department:</label>
          <label className="font-semibold text-xl ">
            {userData?.department}
          </label>
        </span>
      </div>
      <div className="flex h-full max-h-full">
        {/* <div className="grid-span-1"></div> */}
        <div className="grid-span-1 flex flex-col w-full bg-gray-200 p-4 mb-28 rounded-md overflow-y-auto gap-y-4">
          {moods.map((mood) => (
            <div className="flex flex-col rounded w-full gap-y-2 bg-white p-2">
              <label className="text-sm text-gray-700">
                {new Date(mood?.time?.$date).toLocaleString("en-GB", {
                  timeZone: "UTC",
                })}
              </label>

              <label className="w-full text-lg text-center font-semibold">
                {moodValues[mood.mood]}
              </label>
              <label className="w-full text-sm text-center break-all ">
                {mood.note}
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
